import SiteEnum from '@models/enums/SiteEnum';
import { IHotspotCard } from '@models/IHotspotCard';
import { IInspirationCard } from '@models/IInspirationCard';
import { CardData } from '@models/IListingWrapper';
import HotspotCard from '@molecules/HotspotCard/HotspotCard';
import InspirationCard from '@molecules/InspirationCard/InspirationCard';
import { fadeInUpAnimation } from '@utility/config/animations';
import classNames from 'classnames';
import { motion } from 'motion/react';

type BaseProps = {
  readonly handlePosition: (cardType: 'hotspot' | 'inspiration') => string;
  readonly site: SiteEnum;
};

// Hotspot props
type HotspotProps = BaseProps & {
  readonly cardType: 'hotspot';
  readonly hotspotData: CardData;
  readonly selectedFeaturedInspiration: IHotspotCard;
  readonly selectedInspirationCard?: never;
  readonly inspirationData?: never;
};

// Inspiration props
type InspirationProps = BaseProps & {
  readonly cardType: 'inspiration';
  readonly inspirationData: CardData;
  readonly selectedInspirationCard: IInspirationCard;
  readonly selectedFeaturedInspiration?: never;
  readonly hotspotData?: never;
};

type Props = HotspotProps | InspirationProps;

const ListingFeaturedCard = (props: Props) => {
  const { cardType, site, handlePosition } = props;

  if (cardType === 'hotspot') {
    const { selectedFeaturedInspiration, hotspotData } = props;
    return (
      <motion.div
        key={`hotspot-${selectedFeaturedInspiration.link}`}
        variants={fadeInUpAnimation}
        initial="hidden"
        animate="visible"
        exit="hidden"
        className={classNames('tw-h-full', handlePosition('hotspot'))}
      >
        <HotspotCard
          aspectRatio={hotspotData.aspectRatio}
          useNewHotspotButton={site === SiteEnum.B2B}
          showLikeButton={site === SiteEnum.Deco}
          inspirationOverlayItems={
            site === SiteEnum.B2B ? undefined : [selectedFeaturedInspiration]
          }
          cardIndex={0}
          {...selectedFeaturedInspiration}
        />
      </motion.div>
    );
  }

  if (cardType === 'inspiration') {
    const { selectedInspirationCard } = props;
    return (
      <motion.div
        key={`inspiration-${selectedInspirationCard.meta?.contentLink}`}
        variants={fadeInUpAnimation}
        initial="hidden"
        animate="visible"
        exit="hidden"
        className={classNames('tw-h-full', handlePosition('inspiration'))}
      >
        <InspirationCard {...selectedInspirationCard} />
      </motion.div>
    );
  }
};

export default ListingFeaturedCard;
